module.exports = __webpack_public_path__ + "static/media/Main Range of Cookies.659d0f4f.jpg";